var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelinoxLogoVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Helinox",
    viewBox: "0 0 283.46 271.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #231815;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.75,75.04l-73.31,75.04-73.31-75.04L139.45,0l73.31,75.04ZM139.45,150.08c0-41.45,32.82-75.04,73.31-75.04-40.49,0-73.31-33.59-73.31-75.04,0,41.45-32.83,75.04-73.31,75.04,40.49,0,73.31,33.59,73.31,75.04Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.72,269.88h-7.18v-31.72H7.18v31.72H0v-66.11h7.18v27.96h32.36v-27.96h7.18v66.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.27,270.83c-13.41,0-22.42-9.64-22.42-24.01,0-15.44,8.7-25.82,21.66-25.82,18.4,0,18.94,19.54,18.94,21.77,0,1.27,0,2.03-.21,3.02l-.24,1.04h-33.04c.42,11.12,6.19,17.49,15.88,17.49,6.1,0,9.35-1.16,11.94-2.42l1.37-.66,1.93,5.97-.95.53c-1.65.92-6.41,3.09-14.86,3.09h0ZM62.43,240.58h25.62c-.12-2.61-.81-7-3.81-10.04-2.03-2.07-4.82-3.11-8.3-3.11-8.14,0-12.29,6.71-13.52,13.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.74,269.88h-7.18v-69.59h7.18v69.59h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.59,215.24h-.09c-2.46,0-4.39-2.09-4.39-4.76s2.1-4.86,4.58-4.86,4.49,2.14,4.49,4.86-1.97,4.76-4.58,4.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.28,269.88h-7.17v-47.85h7.17v47.85h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.77,270.48h-12.12v-28.18c0-7.66-2.9-11.55-8.63-11.55-4.8,0-8.12,3.59-9.29,7.15-.3.83-.47,2.01-.47,3.27v29.31h-12.12v-35.15c0-5.1-.12-8.75-.37-12.19l-.16-2.06h11.22l.28,4.47c2.45-2.38,6.91-5.41,13.64-5.41,3.01,0,18.01,1.03,18.01,21.31v29.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.44,271.51c-13.99,0-23.76-10.43-23.76-25.36s10.08-26.02,24.51-26.02,23.85,10.39,23.85,25.26c0,17.94-12.75,26.12-24.6,26.12h0ZM213,230.19c-8.3,0-12.02,7.87-12.02,15.68,0,9.03,4.98,15.6,11.84,15.6s11.92-6.63,11.92-15.78c0-7.46-3.67-15.49-11.74-15.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.46,270.48h-13.96l-7.34-11.12c-1.22-1.8-2.33-3.6-3.36-5.31-.95,1.62-2.01,3.31-3.32,5.31l-7.15,11.12h-13.86l17.53-25.17-16.77-24.23h13.92l7.07,10.65c1.08,1.54,2.09,3.07,3.18,4.82.91-1.51,1.91-3.07,3.13-4.91l6.87-10.56h13.79l-16.91,23.98,17.18,25.42h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelinoxLogoVertical);
export default __webpack_public_path__ + "static/media/helinox_logo_vertical.43ea9b7912c1028ddf634a07a5d76e60.svg";
export { ForwardRef as ReactComponent };